<script lang="ts">
  import { subtypesDiligencesService } from '../services';
    import type { SubtypesDiligences } from '../Model/SubtypesDiligences';

  export let crimeSelectId: string;

  let crimes: SubtypesDiligences[];
  let crimesShow: SubtypesDiligences[] = [];


  load();

  async function load() {

    crimes = await subtypesDiligencesService.find();

    for (const crime of crimes) {
      crimesShow.push(crime)
    }

    crimesShow.sort((a, b) => {
      return a.subTypeDiligence < b.subTypeDiligence ? -1 : 1;
    });

    crimesShow = crimesShow;
  }

</script>

{#if crimesShow}
  <div class="input-group">
    <select class="form-select" bind:value={crimeSelectId}>
      {#each crimesShow as crime}
        <option value={crime.id}>{crime.subTypeDiligence}</option>
      {/each}
    </select>
  </div>
{/if}

<style>
</style>
